import { TFunction } from 'i18next';
import PriceVarianceChart from '../charts/PriceVarianceChart';

interface OverviewTabProps {
  t: TFunction<['analysisAndReports', 'dataUpload']>;
}

const OverviewTab = (props: OverviewTabProps) => {
  const { t } = props;
  return (
    <div className="tab overview-tab px-2 pt-8 md:px-8 md:pt-12 lg:pt-14">
      <PriceVarianceChart t={t} />
    </div>
  );
};

export default OverviewTab;
